import React from "react";
import { Clock } from "lucide-react";

const ROWS = [
  { label: "DTF Gang Sheets", days: "Overnight – 2 days", color: "var(--dtf-blue)" },
  {
    label: "Custom Shirts (in stock)",
    days: "3 days minimum",
    color: "var(--dtf-blue)",
    hint: "Out-of-stock sizes/colors add lead time",
  },
  { label: "Stickers, Decals & Label Sheets", days: "2 – 3 days", color: "var(--sc-pink)" },
  { label: "Marketing / Signage", days: "5 – 6 days", color: "var(--sc-purple)", hint: "Varies by product" },
];

export default function TurnaroundStrip() {
  return (
    <section
      className="border-y-2 border-black bg-white"
      data-testid="turnaround-strip"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-6">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 border border-black inline-flex items-center justify-center bg-black text-white" aria-hidden>
            <Clock size={14} />
          </div>
          <p className="label-mono">
            PRODUCTION TURNAROUND · <span className="text-[color:var(--muted-text)]">in-shop days before we ship</span>
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {ROWS.map((r) => (
            <div
              key={r.label}
              className="border border-black p-3"
              style={{ boxShadow: `3px 3px 0 0 ${r.color}` }}
              data-testid={`turnaround-strip-row-${r.label.split(" ")[0].toLowerCase()}`}
            >
              <p className="label-mono" style={{ color: r.color }}>{r.label}</p>
              <p className="font-mono text-sm font-bold mt-1">{r.days}</p>
              {r.hint && (
                <p className="label-mono text-[9px] text-[color:var(--muted-text)] mt-1">{r.hint}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
